import { useRef, useEffect, useState } from "react";
import "./Partners.css";

export default function Partners({
    title = "NUESTROS PARTNERS",
    partners = [
        { src: "/img/Logos/monster_white.png", alt: "Monster Energy partner" },
        { src: "/img/Logos/aorus_white.png", alt: "Aorus partner" },
        { src: "/img/Logos/lewagon_white.png", alt: "Le Wagon partner" },
        { src: "/img/Logos/avalanche.png", alt: "Avalanche partner" },
    ],
}) {
    const trackRef = useRef(null);
    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        if (window.innerWidth > 640) return;

        const track = trackRef.current;
        if (!track) return;

        let index = 0;
        let interval = null;

        const goTo = (i) => {
            index = i % partners.length;
            track.scrollTo({
                left: track.clientWidth * index,
                behavior: "smooth",
            });
            setActiveIndex(index);
        };

        const start = () => {
            interval = setInterval(() => {
                goTo(index + 1);
            }, 3000);
        };

        const stop = () => {
            clearInterval(interval);
        };

        start();

        const handleScroll = () => {
            const i = Math.round(track.scrollLeft / track.clientWidth);
            setActiveIndex(i);
            index = i;
        };
        track.addEventListener("scroll", handleScroll, { passive: true });

        track.addEventListener("touchstart", stop);
        track.addEventListener("touchend", start);

        return () => {
            stop();
            track.removeEventListener("scroll", handleScroll);
        };
    }, [partners.length]);

    return (
        <section id="partners" className="partners">
            <div className="partners-inner">
                <h2 className="partners-title">{title}</h2>

                {/* --- Desktop Grid --- */}
                <ul className="partners-logosGrid">
                    {partners.map((p) => (
                        <li className="partner" key={p.alt}>
                            <img src={p.src} alt={p.alt} loading="lazy" />
                        </li>
                    ))}
                </ul>

                {/* --- Mobile Swiper --- */}
                <div className="partners-swiper">
                    <ul className="partners-track" ref={trackRef}>
                        {partners.map((p, i) => (
                            <li className="partner-slide" key={i}>
                                <img src={p.src} alt={p.alt} loading="lazy" />
                            </li>
                        ))}
                    </ul>

                    <div className="partners-dots">
                        {partners.map((_, i) => (
                            <button
                                key={i}
                                className={`dot ${activeIndex === i ? "is-active" : ""}`}
                                aria-label={`Ir al logo ${i + 1}`}
                                onClick={() => {
                                    const track = trackRef.current;
                                    if (!track) return;
                                    track.scrollTo({
                                        left: track.clientWidth * i,
                                        behavior: "smooth",
                                    });
                                }}
                            />
                        ))}
                    </div>
                </div>
            </div>

        </section>
    );
}
